var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[(_vm.$route.meta.logLayout===false)?_c('layout-default',{staticClass:"h-100"}):_vm._e(),(_vm.$route.meta.logLayout)?_c('layout-log'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }